import { upperFirst, camelCase } from 'lodash';

export function pascalCase(string) {
  return upperFirst(camelCase(string));
}

// TODO: Replace with something much more sophisticated.
export function singularize(string, count) {
  if (count && count !== 1) {
    return pluralize(string);
  }

  if (string[string.length - 1] !== 's') return string;
  return string.slice(0, -1);
}

// TODO: Replace with something much more sophisticated.
export function pluralize(string, count) {
  if (count === 1) {
    return singularize(string);
  }

  if (string[string.length - 1] === 's') return string;
  return string + 's';
}
